import { TProductRefId, TProductRefIdV1 } from "@/types/plan";
import { PLAN_RULE_BOOK_FOR_V1 } from "../data";

export function getEquivalentPlanIds(
  productId: TProductRefIdV1,
): TProductRefId[] {
  return PLAN_RULE_BOOK_FOR_V1[productId];
}
